module.exports = __webpack_public_path__ + "img/main-4.1819a66b.svg";